import React from "react";
import {
  CCard,
  CCardHeader,
  CCardBody,
  CNavLink,
  CRow,
  CCol,
  CListGroup,
  CListGroupItem,
} from "@coreui/react-pro";
import { useNavigate } from "react-router-dom";
import { GoogleMapsComponent } from "./Map";
import { useHotelData } from "./Map";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";

const MapHotels = () => {
  const navigate = useNavigate();
  const { hotels } = useHotelData();

  const handleHotelClick = (hotel) => {
    if (hotel.Shower_Room_Availability) {
      navigate(`/book-shower/${hotel.Hotel_Description}`);
    } else {
      toast.error("The hotel is currently unavailable");
    }
  };

  return (
    <div>
      <GoogleMapsComponent />
    </div>
  );
};

export default MapHotels;
